<div class="d-flex flex-column main-section">
    @if (finalConclusion?.message) {
        <div class="message-section">
            {{ finalConclusion?.message }}
        </div>
    }
    @if (!finalConclusion.hideScore) {
        <div class="d-flex flex-row score-author-section">
            @if (!isEditMode) {
                <div class="d-flex flex-column author-section">
                    <div class="label">{{ finalConclusion.authorLabelKey | transloco }}</div>
                    <div class="d-flex flex-row">
                        <div class="circle">
                            <p class="circle-inner">{{ initials }}</p>
                        </div>
                        <div class="author-name">{{ finalConclusion.author }}</div>
                    </div>
                </div>
            }
            <div class="d-flex flex-column score-section">
                <div class="label">{{ 'controls.effFinalConclusionBox.finalScore' | transloco }}</div>
                @if (isEditMode) {
                    <eff-colored-selector
                        [options]="finalConclusion.availableScores"
                        [(model)]="finalConclusion.score"
                    />
                } @else {
                    <div
                        [style.background-color]="finalConclusion.scoreColor"
                        class="final-score-view"
                    >
                        {{ finalConclusion.scoreName }}
                    </div>
                }
            </div>
        </div>
    }
    <div class="comment-section">
        @if (isEditMode) {
            <eff-textarea
                class="grid-textarea-style"
                [(model)]="finalConclusion.conclusion"
                [popupEnabled]="false"
                [label]="'controls.effFinalConclusionBox.addComment' | transloco"
            ></eff-textarea>
        } @else {
            <div class="comment-readonly">{{ finalConclusion.conclusion }}</div>
        }
    </div>
</div>
